import { useCallback } from 'react';

import { useTrackPausedVideo } from '@air/analytics';

import { usePlayerStore } from '../components/PlayerContextProvider';
import { usePlayerTransportController } from '../components/PlayerTransportProvider';

export const usePlayerPause = () => {
  const { transportController } = usePlayerTransportController();
  const id = usePlayerStore((state) => state.id);
  const videoElement = usePlayerStore((state) => state.videoElement);
  const { trackPausedVideo } = useTrackPausedVideo();

  const onPlayerPause = useCallback(() => {
    if (transportController) {
      transportController.pause();
      return;
    }

    if (videoElement) {
      videoElement.pause();
      trackPausedVideo({ id });
    }
  }, [transportController, videoElement, id, trackPausedVideo]);

  return { onPlayerPause };
};
